
const initialState = null;

const userReducer = (state = initialState, action) => {
    switch(action.type) {
        case 'LOGGEDIN_SUCCESS' : {
            return {
                login : true,
                ...action.payload.user
            }
        }break;
        case  'LOGGED_OUT' : {
            return {
                login : false
            }
        }break;
        default : {
            return state;
        }break;
    }
}

export default userReducer;


// WEBPACK FOOTER //
// ./src/reducers/userReducer.js